const QuestionData = [
  {
    id: 1,
    field: 'sex',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '你的性别',
    field_type: 0,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f2a5ff798d58c918b4bd7eb12552b427.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/275ed0a2d34a22c70e0c46c9948a8cc6.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b7bd9c9eba9d7e536a0df7574c9c1a54.png',
    field_unit: [
      {
        key: 1,
        jumpId: 2,
        value: '我是男生',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/708cda10c03b96d0877976a1b4cc6ac9.png',
          width: 104,
          height: 301,
          left: 63,
          top: 135,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 61,
          top: 463
        }
      },
      {
        key: 2,
        jumpId: 2,
        value: '我是女生',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e0e98dc48a0fa7ea6f766052b43870bc.png',
          width: 104,
          height: 301,
          right: 63,
          top: 135,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          right: 61,
          top: 463
        }
      }
    ]
  },
  {
    id: 2,
    field: 'age',
    is_required: 1,
    is_show: 1,
    max_num: 16,
    min_num: 130,
    field_title: '你的年龄',
    field_type: 5,
    bgImage: '',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bb0ea4ef3928d2b9574fa78003685e3f.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/939b837ae2e0a08618c3f78210055722.png',
    field_unit: [
      {
        key: 1,
        value: '',
        jumpId: 6
      }
    ]
  },
  {
    id: 3,
    field: 'height',
    is_required: 1,
    is_show: 1,
    max_num: 230,
    min_num: 100,
    field_title: '身高',
    field_type: 5,
    field_unit: [
      {
        key: 1,
        value: '',
        jumpId: 6
      }
    ]
  },
  {
    id: 4,
    field: 'weight',
    is_required: 1,
    is_show: 1,
    max_num: 200,
    min_num: 30,
    field_title: '体重',
    field_type: 5,
    field_unit: [
      {
        key: 1,
        value: '',
        jumpId: 6
      }
    ]
  },
  {
    id: 5,
    field: 'nutritional_goal_weight',
    is_required: 1,
    is_show: 1,
    max_num: 200,
    min_num: 30,
    field_title: '目标体重',
    field_type: 5,
    field_unit: [
      {
        key: 1,
        value: '',
        jumpId: 6
      }
    ]
  },
  {
    id: 6,
    field: 'breakfast',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '新的一天开始了,你通常会选择什么作为快手早餐？',
    field_type: 0,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eec12f224e87d5c944b2fb432031c4ed.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bcbb73a4e8306dd55649eb5ab96e584d.png',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6a8fa4093512831a591ad9ab89bc1fc.png',
    field_unit: [
      {
        key: 1,
        jumpId: 7,
        value: '包子、米粉、\n面包等米面类食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a19b8626f4ca9915e147e16fe6788ba6.png',
          width: 136,
          height: 118,
          left: 187,
          top: 100,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 72,
          top: 124
        }
      },
      {
        key: 2,
        jumpId: 7,
        value: '香蕉、火龙果、\n甜枣等甜味水果',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d983f4c4cbc0e8b7721beea62481730b.png',
          width: 151,
          height: 136,
          left: 44,
          top: 196,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 157,
          top: 237
        }
      },
      {
        key: 3,
        jumpId: 7,
        value: '红薯、玉米等粗粮类食物'
      },
      {
        key: 4,
        jumpId: 7,
        value: '全麦面包、鸡蛋、\n坚果等低甜味食物'
      },
      {
        key: 5,
        jumpId: 7,
        value: '没有吃早餐的习惯'
      }
    ]
  },
  {
    id: 7,
    field: 'feel',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '今天的工作/学习中,遇到了棘手的问题，你常出现以下的感受吗？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    questionImageData: {
      //问题背景图
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-a',
      width: 312,
      height: 311,
      left: 10,
      top: 100,
      animateName: 'animate__slideInLeft'
    },
    field_unit: [
      {
        key: 1,
        jumpId: 8,
        value: '精神紧绷、难以放松',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 8,
        value: '容易焦虑',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 8,
        value: '容易感到急躁、不耐烦',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 8,
        value: '情绪较稳定，会积极应对',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 8,
    field: 'afternoon',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '到了下午，突然有点嘴馋,此时你会倾向于？',
    field_type: 0,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    questionImageData: {
      //问题背景图
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-a',
      width: 312,
      height: 311,
      left: 10,
      top: 100,
      animateName: 'animate__slideInLeft'
    },
    field_unit: [
      {
        key: 1,
        jumpId: 9,
        value: '没精神或情绪低落，吃\n点有味道的食物会得到缓解',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 9,
        value: '可以忍住不吃',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 9,
        value: ' 下一餐我一\n定要大吃一顿',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 9,
        value: '吃点坚果、草\n莓等无负担小零食',
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 9,
    field: 'afternoon_tea',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '公司/学校下午茶,出现了这些食物，你一定会选择的是？',
    field_type: 0,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 10,
        value: '辣条、薯片等\n盐味碳水类食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 10,
        value: '蛋挞、爆米花、饼\n干等甜味碳水类食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 10,
        value: '奶油蛋糕、奶茶、\n冰激淋等奶类食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 10,
        value: '炸串、炸鸡、\n薯条等油炸食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 5,
        jumpId: 10,
        value: '沙拉、圣女\n果等清淡食物',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 10,
    field: 'lunch_after',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '午饭后，你通常会觉得？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 11,
        value: '放空，注意力难以集中',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 11,
        value: '疲惫，需好好睡一觉',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 11,
        value: '神清气爽，精神饱满',
        extra: [],
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 11,
    field: 'skin',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '到了下午,你的皮肤状态更倾向于？',
    field_type: 0,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 12,
        value: '皮肤比较干',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 12,
        value: '皮肤外油内\n干，可能易泛红',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 12,
        value: '皮肤出油严重',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 12,
        value: '中性肤质，\n整体状态不错',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 12,
    field: 'menstrual_period',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '以下哪种描述,比较贴合你的经期情况？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    other_rule: [
      {
        rule_id: 2,
        type: 2,
        subject_id: 1,
        answer_id: 2,
        judge_type: 1
      }
    ],
    field_unit: [
      {
        key: 1,
        jumpId: 13,
        value: '时间不规律',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 13,
        value: '经量比较少',
        extra: [3, 4],
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 13,
        value: ' 经量比较大',
        extra: [2, 4],
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 13,
        value: '时间规律，经期正常',
        extra: [],
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 13,
    field: 'menstrual_period_feel',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '经前或经期时,你会有以下的感觉吗？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    other_rule: [
      {
        rule_id: 2,
        type: 2,
        subject_id: 1,
        answer_id: 2,
        judge_type: 1
      }
    ],
    field_unit: [
      {
        key: 1,
        jumpId: 14,
        value: '胸部肿胀',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 14,
        value: '明显的头痛',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 14,
        value: '痛经',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 14,
        value: '烦躁，容易生气\n或突然感觉低落沮丧',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 5,
        jumpId: 14,
        value: '以上都没有',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 14,
    field: 'sleep',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '以下哪种描述,比较贴合你的睡眠情况？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    questionImageData: {
      //问题背景图
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-a',
      width: 312,
      height: 311,
      left: 10,
      top: 100,
      animateName: 'animate__slideInLeft'
    },
    field_unit: [
      {
        key: 1,
        jumpId: 15,
        value: '睡眠较浅，有\n一点动静就会醒来',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 15,
        value: '经常做梦',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 15,
        value: '白天睡不\n醒，晚上睡不着',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 15,
        value: '入睡不算困\n难，睡眠较深',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 15,
    field: 'fat',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '照镜子时,您觉得自己哪个部位的脂肪最多？',
    field_type: 0,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 16,
        value: '腰腹',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 16,
        value: '臀腿',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 16,
        value: '全身',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 16,
    field: 'symptom',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '平时在生活中,你是否存在以下现象？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 17,
        value: '手脚时常冰凉',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 17,
        value: '指甲脆弱，容易断',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 17,
        value: '掉发，每次梳\n头都能掉一小把',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 17,
        value: '以上都没有',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 17,
    field: 'symptom2',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '你的身体,是否存在以下的某种症状？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 18,
        value: '特别容易长痘',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 18,
        value: '到了晚上易小腿或脚水肿',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 18,
        value: '腿部莫名抽筋',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 18,
        value: '以上都没有',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 18,
    field: 'illness',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '您经历过或者 目前有以下疾病吗？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    questionImageData: {
      //问题背景图
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-a',
      width: 312,
      height: 311,
      left: 10,
      top: 100,
      animateName: 'animate__slideInLeft'
    },
    field_unit: [
      {
        key: 1,
        jumpId: 19,
        value: ' 代谢类（糖尿病等）',
        positionData: {
          left: 69,
          top: 113
        }
      },
      {
        key: 2,
        jumpId: 19,
        value: '甲状腺类（甲状腺<br/>炎，甲亢，甲减等）',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 19,
        value: ' 卵巢类（多囊<br/>卵巢综合征等）',
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 19,
        value: '子宫或乳腺类疾病（子<br/>宫肌瘤、乳腺增生等）',
        positionData: {
          left: 34,
          top: 484
        }
      },
      {
        key: 5,
        jumpId: 19,
        value: '以上都没有',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 19,
    field: 'perplex',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '除了身材以外,你是否有下列困扰？',
    field_type: 1,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    field_unit: [
      {
        key: 1,
        jumpId: 20,
        value: ' 皮肤松弛',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 2,
        jumpId: 20,
        value: '双下巴明显',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 3,
        jumpId: 20,
        value: '有拜拜肉',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 4,
        jumpId: 20,
        value: '时常便秘',
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q12-a',
          width: 145,
          height: 145,
          left: 10,
          top: 100,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 169,
          top: 484
        }
      },
      {
        key: 5,
        jumpId: 20,
        value: '以上都没有',
        extra: [],
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  },
  {
    id: 20,
    field: 'exercise',
    is_required: 1,
    is_show: 1,
    max_num: 0,
    min_num: 0,
    field_title: '你的运动频率是？',
    field_type: 0,
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-head',
    titleImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-title',
    questionImageData: {
      //问题背景图
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q14-a',
      width: 312,
      height: 311,
      left: 10,
      top: 100,
      animateName: 'animate__slideInLeft'
    },
    field_unit: [
      {
        key: 1,
        jumpId: 0,
        value: '基本不运动',
        positionData: {
          left: 87,
          top: 116
        }
      },
      {
        key: 2,
        jumpId: 0,
        value: '偶尔运动\n（一周2-3次）',
        positionData: {
          left: 187,
          top: 234
        }
      },
      {
        key: 3,
        jumpId: 0,
        value: '经常运动（一\n周四到五次）',
        positionData: {
          left: 42,
          top: 332
        }
      },
      {
        key: 4,
        jumpId: 0,
        value: '高强度规律运\n动（运动员）',
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  }
]
const QuestionImageData = [
  {
    id: 1,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f2a5ff798d58c918b4bd7eb12552b427.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/275ed0a2d34a22c70e0c46c9948a8cc6.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b7bd9c9eba9d7e536a0df7574c9c1a54.png',
      width: 98,
      height: 34,
      left: 139,
      top: 52,
      animateName: 'animate__slideInUp'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/708cda10c03b96d0877976a1b4cc6ac9.png',
          width: 104,
          height: 301,
          left: 63,
          top: 135,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 61,
          top: 463
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e0e98dc48a0fa7ea6f766052b43870bc.png',
          width: 104,
          height: 301,
          right: 63,
          top: 135,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          right: 61,
          top: 463
        }
      }
    ]
  },
  {
    id: 2,
    bgImage: '',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bb0ea4ef3928d2b9574fa78003685e3f.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/939b837ae2e0a08618c3f78210055722.png',
      width: 196,
      height: 34,
      left: 90,
      top: 52,
      animateName: 'animate__slideInDown'
    }
  },
  {
    id: 3
  },
  {
    id: 4
  },
  {
    id: 5
  },
  {
    id: 6,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eec12f224e87d5c944b2fb432031c4ed.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bcbb73a4e8306dd55649eb5ab96e584d.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c6a8fa4093512831a591ad9ab89bc1fc.png',
      width: 218,
      height: 56,
      right: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a19b8626f4ca9915e147e16fe6788ba6.png',
          width: 136,
          height: 118,
          left: 197,
          top: 97,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 72,
          top: 113
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d983f4c4cbc0e8b7721beea62481730b.png',
          width: 151,
          height: 136,
          left: 44,
          top: 191,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 152,
          top: 225
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/61cb6ef7d7ba961a4581cb1c603aa6f1.png',
          width: 131,
          height: 152,
          left: 227,
          top: 304,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 51,
          top: 344
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b28428e3c1b33151cf29a57bb1d2130f.png',
          width: 177,
          height: 104,
          left: 51,
          top: 432,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 139,
          top: 452
        }
      },
      {
        imageData: null,
        positionData: {
          left: 98,
          top: 563
        }
      }
    ]
  },
  {
    id: 7,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f8c9684e2d5ac295c90a7aff15fc1e07.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3e73add74843f75cd463190d7c656e40.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/83311015b004c679734065d2c24bbcc3.png',
      width: 211,
      height: 94,
      left: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d4d5821a57840b441270ee94ce7eb561.png',
          width: 307,
          height: 311,
          left: 45,
          top: 98,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 44,
          top: 183
        }
      },
      {
        positionData: {
          left: 219,
          top: 245
        }
      },
      {
        positionData: {
          left: 128,
          top: 392
        }
      },
      {
        positionData: {
          left: 72,
          top: 471
        }
      }
    ]
  },
  {
    id: 8,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ff375f997d8fba894e5ff9ee0d5e059a.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b6175a968391b190949dd1c302614dec.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4446c3c6b8c14596ef50a123bf7e5764.png',
      width: 271,
      height: 52,
      right: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/47ab2e3b709efd33ce038e46e22dadb1.png',
          width: 282,
          height: 411,
          left: 45,
          top: 117,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 65,
          top: 133
        }
      },
      {
        imageData: null,
        positionData: {
          left: 199,
          top: 281
        }
      },
      {
        imageData: null,
        positionData: {
          left: 32,
          top: 336
        }
      },
      {
        imageData: null,
        positionData: {
          left: 133,
          top: 503
        }
      }
    ]
  },
  {
    id: 9,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f7c82f1e4960777c320a367bf556b09.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/03e014572a9005463dda0ca1bf4c800c.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/de795debbd945c180ddda9ffc8521a56.png',
      width: 241,
      height: 52,
      left: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c97a495b335225f707166db0aa2bdccd.png',
          width: 127,
          height: 69,
          left: 210,
          top: 84,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 196,
          top: 137
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a45545b6b326f1707de7773019e35985.png',
          width: 100,
          height: 74,
          left: 72,
          top: 159,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 30,
          top: 224
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c56117f07b9bdb805b8697b92f733ef5.png',
          width: 88,
          height: 147,
          left: 231,
          top: 239,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 166,
          top: 328
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/716d168f4d8e305fceaca94daf1ade19.png',
          width: 145,
          height: 107,
          left: 32,
          top: 373,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 30,
          top: 438
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fac4baaeacf45f5ce7a510f6f987b944.png',
          width: 143,
          height: 93,
          left: 197,
          top: 455,
          animateName: 'animate__slideInRight'
        },
        positionData: {
          left: 199,
          top: 523
        }
      }
    ]
  },
  {
    id: 10,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f7f47a8a571f81d863dcfd82f5ae2c85.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c82c492f2b4f24dd29cf8643386fb8c7.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b95305520506f15e7980a8f230bc53b8.png',
      width: 261,
      height: 51,
      right: 20,
      top: 16,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/79194500744d95316f56841b487ec573.png',
          width: 110,
          height: 110,
          left: 231,
          top: 108,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 34,
          top: 140
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d4c838629fc86b51387d5c20b7be9d3e.png',
          width: 110,
          height: 110,
          left: 42,
          top: 258,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 138,
          top: 290
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9a795d13e18e4f7c0c85d16ba4b505f6.png',
          width: 110,
          height: 110,
          left: 225,
          top: 408,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 42,
          top: 440
        }
      }
    ]
  },
  {
    id: 11,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/096c8fbd03a889c6743cff1c4acccb71.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/af52382c57a1620b667555e64df5c65a.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/75a585fec441744dbbdfd806ce9f23fd.png',
      width: 155,
      height: 52,
      left: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3372d8c51f1358e073d15fca2be05a04.png',
          width: 110,
          height: 110,
          left: 213,
          top: 96,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 96,
          top: 132
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/82d0a5892d3520e70f5697c944c1dbf7.png',
          width: 110,
          height: 110,
          left: 45,
          top: 228,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 135,
          top: 249
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac6a017f57a43db126cd7265da967b27.png',
          width: 110,
          height: 110,
          left: 210,
          top: 355,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 71,
          top: 387
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f402ac691a2e686f0386f98be25a3513.png',
          width: 110,
          height: 110,
          left: 69,
          top: 481,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 164,
          top: 501
        }
      }
    ]
  },
  {
    id: 12,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c31f6d4eb824ae563f35a0e8026ebe48.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9bf844a5bafb868709649458b3dd7b9e.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/65000657130daf50a8e0e343ddfc8349.png',
      width: 155,
      height: 75,
      right: 20,
      top: 16,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d4af5682b237859c5152d0c7af7886ea.png',
          width: 110,
          height: 110,
          left: 53,
          top: 81,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 149,
          top: 113
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3638d5bba73b892f009e59ef63efac4d.png',
          width: 110,
          height: 110,
          left: 213,
          top: 199,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 92,
          top: 231
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b174a54b393d2bc9df4759d2de7ff675.png',
          width: 110,
          height: 110,
          left: 70,
          top: 316,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 165,
          top: 348
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/148c456666255fa24c882b4b7391c169.png',
          width: 110,
          height: 110,
          left: 220,
          top: 434,
          animateName: 'animate__bounceIn'
        },
        positionData: {
          left: 44,
          top: 466
        }
      }
    ]
  },
  {
    id: 13,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/253f28a1f143337c237de9b85c5e1111.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/38812af03cc2da360bcff6bab5b97713.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7608e4946a80aa638f7a4f287fe4f95a.png',
      width: 148,
      height: 73,
      left: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/774497dc06b8225513385d39da21bf35.png',
          width: 110,
          height: 110,
          left: 219,
          top: 56,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 214,
          top: 158
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/acdfa64136d518e6d5105369395f7723.png',
          width: 110,
          height: 110,
          left: 57,
          top: 109,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 44,
          top: 212
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5975f406f172ae1432b72954a096c12f.png',
          width: 110,
          height: 110,
          left: 219,
          top: 244,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 227,
          top: 347
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ccbb717849f525588fea42f41b56e5db.png',
          width: 110,
          height: 110,
          left: 65,
          top: 285,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 32,
          top: 387
        }
      },
      {
        imageData: null,
        positionData: {
          left: 178,
          top: 482
        }
      }
    ]
  },
  {
    id: 14,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c9d818a94682545d7af8f025449907a4.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/02379b2d779a013a4ff09c4f67676bc6.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ee7cdb7981282c289037a52f3abc7d05.png',
      width: 155,
      height: 75,
      right: 20,
      top: 16,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/debf6160c4cf06fb861394738c4883c6.png',
          width: 330,
          height: 369,
          left: 25,
          top: 121,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 47,
          top: 120
        }
      },
      {
        imageData: null,
        positionData: {
          left: 210,
          top: 195
        }
      },
      {
        imageData: null,
        positionData: {
          left: 50,
          top: 347
        }
      },
      {
        imageData: null,
        positionData: {
          left: 184,
          top: 454
        }
      }
    ]
  },
  {
    id: 15,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9f90bd3142c7bd23d941c82e71bc172c.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b3cb18209941332d3f49f2d80e78fbef.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/feb2cc270e8d631390a42608302ffade.png',
      width: 214,
      height: 52,
      left: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/45465f41a98999394ec8f2e43d02a6ca.png',
          width: 152,
          height: 152,
          left: 181,
          top: 93,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 113,
          top: 152
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d5b1f8f928f2e425dd4f4dbfec4018c8.png',
          width: 152,
          height: 152,
          left: 42,
          top: 252,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 172,
          top: 315
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/451b23aee3825bc64650557ec8d4f54a.png',
          width: 152,
          height: 152,
          left: 181,
          top: 413,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 113,
          top: 475
        }
      }
    ]
  },
  {
    id: 16,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cf015f9724742fba4dcd5421a21be99f.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d6ab4f2777467f1f6bd70d46f2cc97e6.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6acf4bb79986e48b464b789b96dd835b.png',
      width: 148,
      height: 73,
      left: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/68706a32cc5a24ee5b1de76de0f641fe.png',
          width: 110,
          height: 110,
          left: 224,
          top: 88,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 94,
          top: 120
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6fe7235b1e3aa09e89ce039b8141ad1e.png',
          width: 110,
          height: 110,
          left: 36,
          top: 198,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 122,
          top: 230
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a3ee12ce80e8869be90d7dfb0c4931a8.png',
          width: 110,
          height: 110,
          left: 200,
          top: 318,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 72,
          top: 337
        }
      },
      {
        imageData: null,
        positionData: {
          left: 149,
          top: 461
        }
      }
    ]
  },
  {
    id: 17,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ef0158b0899f8749a8a4a56780e55acf.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7fce51c0d1e20656a63d16f6aaab250c.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/36bd16172868b714e29010b55ae9ed23.png',
      width: 170,
      height: 73,
      right: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/98bd9535e924234b20293cbd0b35e1af.png',
          width: 110,
          height: 110,
          left: 63,
          top: 96,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 150,
          top: 128
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/bdd1927a9e37be1a1fd54bd3766d42ae.png',
          width: 110,
          height: 110,
          left: 227,
          top: 214,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 40,
          top: 246
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7da927bfca05293badb34bca4a78caf5.png',
          width: 110,
          height: 110,
          left: 68,
          top: 328,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 156,
          top: 360
        }
      },
      {
        imageData: null,
        positionData: {
          left: 139,
          top: 461
        }
      }
    ]
  },
  {
    id: 18,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1f9b6c845ca0890c022934f48200d262.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b124859d107de1f69e5a1a3f3fe03f84.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/933a8ef25b8a2c6259dda96efd23d34b.png',
      width: 211,
      height: 85,
      left: 20,
      top: 8,
      animateName: 'animate__slideInRight'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ace34fab02f57ac559a4699cc94be09f.png',
          width: 232,
          height: 210,
          left: 76,
          top: 180,
          animateName: 'animate__zoomIn'
        },
        positionData: {
          left: 69,
          top: 113
        }
      },
      {
        imageData: null,
        positionData: {
          left: 148,
          top: 183
        }
      },
      {
        imageData: null,
        positionData: {
          left: 196,
          top: 302
        }
      },
      {
        imageData: null,
        positionData: {
          left: 34,
          top: 403
        }
      },
      {
        imageData: null,
        positionData: {
          left: 186,
          top: 490
        }
      }
    ]
  },
  {
    id: 19,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b03d0791935c9987c998fe3b944add59.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/16afecf9f6eedf3ffd99dbbe4ccb43e8.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/79a4e9be0952c750b55180d7a7841079.png',
      width: 148,
      height: 73,
      right: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1d09038c95056429f8c655c2c42fb3c7.png',
          width: 110,
          height: 110,
          left: 61,
          top: 61,
          animateName: 'animate__fadeInUp'
        },
        positionData: {
          left: 56,
          top: 163
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/01be558950793cc3e30177263610626f.png',
          width: 110,
          height: 110,
          left: 211,
          top: 122,
          animateName: 'animate__fadeInUp'
        },
        positionData: {
          left: 198,
          top: 224
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/66b5a2eddbb259f55b6bab171247722a.png',
          width: 110,
          height: 110,
          left: 52,
          top: 254,
          animateName: 'animate__fadeInUp'
        },
        positionData: {
          left: 45,
          top: 353
        }
      },
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/352843b700db5d1362a37a3c8ab80b13.png',
          width: 110,
          height: 110,
          left: 211,
          top: 309,
          animateName: 'animate__fadeInUp'
        },
        positionData: {
          left: 206,
          top: 401
        }
      },
      {
        imageData: null,
        positionData: {
          left: 87,
          top: 474
        }
      }
    ]
  },
  {
    id: 20,
    bgImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5505d87704bc58865365968efb22f910.png',
    indexImage:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8fed88c75fb69063978a00d2f1dc3e13.png',
    titleImage: {
      //选项图片
      url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f1d4bfd922e149787d20a1533325cc73.png',
      width: 184,
      height: 28,
      right: 20,
      top: 8,
      animateName: 'animate__slideInLeft'
    },
    options: [
      {
        imageData: {
          //选项图片
          url: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/81348c0c5b2c9a2e7f211c48680c2916.png',
          width: 311,
          height: 309,
          left: 28,
          top: 173,
          animateName: 'animate__slideInLeft'
        },
        positionData: {
          left: 87,
          top: 116
        }
      },
      {
        imageData: null,
        positionData: {
          left: 187,
          top: 234
        }
      },
      {
        imageData: null,
        positionData: {
          left: 42,
          top: 332
        }
      },
      {
        imageData: null,
        positionData: {
          left: 169,
          top: 484
        }
      }
    ]
  }
]
export { QuestionData, QuestionImageData }
